module.exports = __webpack_public_path__ + "static/media/revenue-operations-feature-1.38909825.svg";